module.exports = __webpack_public_path__ + "img/PMS_vid .1d81244c.png";